import { StripeCoupon } from "@cruisen/contract"

export const calculateDiscountedPrice = (
  price: number,
  discount: StripeCoupon | null,
): { activePrice: number; discountPercentOff: number } => {
  if (!discount) return { activePrice: price, discountPercentOff: 0 }

  const discountAmountOff = discount.amount_off ? discount.amount_off / 100 : 0
  const discountPercentOff = discount.percent_off ?? 0

  if (discountAmountOff) {
    return {
      activePrice: price - discountAmountOff,
      discountPercentOff: discountPercentOff || (discountAmountOff / price) * 100,
    }
  } else if (discountPercentOff) {
    return { activePrice: (price / 100) * (100 - discountPercentOff), discountPercentOff }
  }

  return { activePrice: price, discountPercentOff: 0 }
}

export const getDiscountDurationText = (durationInMonths: number | null): string => {
  let years = 0
  let months = 0

  if (durationInMonths) {
    years = Math.floor(durationInMonths / 12)
    months = durationInMonths % 12
  }

  let durationText = ""

  if (years > 0) {
    if (years > 1) {
      durationText += `${years} years`
    } else {
      durationText += `a year`
    }
  }

  if (durationText && months > 0) {
    durationText += " and "
  }

  if (months > 0) {
    if (months > 1) {
      durationText += `${months} months`
    } else {
      durationText += `a month`
    }
  }

  return durationText
}
